import DecisionNodeBase from '~/models/journey/DecisionNodeBase'
import type { WaypointNode } from '~/models/journey/waypoints'
import type { Path } from '~/types/util'

export default class AskPlanYearNode extends DecisionNodeBase {
  getNext(): WaypointNode | Path | null {
    const { flag } = FeatureFlags.use()
    const askPlanYear = computed(() => flag<boolean>('ask-plan-year').value)

    return this.yesNo(askPlanYear.value)
  }
}
